export default __webpack_public_path__ + "static/media/5f-dark-logo.df9500a3.png";